import React from 'react'
import { IProductMlaiForCreate } from '../../../../../modules/API/Mlai/models/productsForCreate'
import TitleLayout from '../../kosherTeudot/generic/TitleLayout'
import TitleRow from '../../kosherTeudot/generic/TitleRow'
import TitleRowItem from '../../kosherTeudot/generic/TitleRowItem'
import AcceptIcon from '../../../../../generic/icons/IconLib/CheckIcon'
import AppleIcon from '../../../../../generic/icons/IconLib/AppleIcon'
import PackageIcon from '../../../../../generic/icons/IconLib/PackageBoxIcon'
import UserIcon from '../../../../../generic/icons/IconLib/UserIcon'
import EditIcon from '../../../../../generic/icons/IconLib/PencilIcon'
import PlusIcon from '../../../../../generic/icons/IconLib/PlusIcon'
import RowInput from '../../../../../generic/inputs/RowInput'
import ProductImage from '../../queries/TeudotDetails/Components/ProductImage'
import styled from 'styled-components'
import CircleActiveFilterBtn from '../../../../../generic/particles/CircleActiveFilterBtn'

interface Props extends IProductMlaiForCreate {
  item: IProductMlaiForCreate,
  index: number,
  handleChangeQty: (qty: number, item: IProductMlaiForCreate) => void
  disabled?: boolean,
  handleSaveFunc?: (item: IProductMlaiForCreate) => void
  handleOpenGrowerModal?: (item: IProductMlaiForCreate) => void
  handleOpenAddModal?: (item: IProductMlaiForCreate) => void
}

const ProductItem = ({
  index, handleChangeQty, WeightActual, isEdited,
  NumPackagesActulal, ProductDesc, VarietyDesc, disabled,
  GeneralProductID, ProductID, GrowerName, GrowerID, item,
  handleSaveFunc, SizeID, handleOpenGrowerModal, handleOpenAddModal
}: Props) => {
  const weightPerPack = WeightActual && NumPackagesActulal ?  
  WeightActual / NumPackagesActulal : 0
  const [prev, setPrev] = React.useState<number>(0)
   
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if(Number(e.target.value) === 0) {
      setPrev(Number(e.target.value))
    }
    handleChangeQty(Number(e.target.value), item)
  }
  
  const handleSave = () => {
    if(handleSaveFunc) {
      handleSaveFunc(item)
    }
  }

  const handleGrowerClick = () => {
    if(handleOpenGrowerModal) {
      handleOpenGrowerModal(item)
    }
  }

  const handleAddClick = () => {
    if(handleOpenAddModal) {
      handleOpenAddModal(item)
    }
  }

  return (
    <TitleLayout>
      <SidleWrapper>
        {
          isEdited ? 
          <CircleActiveFilterBtn
            func={handleSave}
          >
            <AcceptIcon />
          </CircleActiveFilterBtn>
          :
          <ProductImage 
            id={GeneralProductID}
          />
        }
        {handleOpenAddModal && (
          <AddButtonWrapper onClick={handleAddClick}>
            <PlusIcon />
          </AddButtonWrapper>
        )}
      </SidleWrapper>
      <TitleRow>
        <TitleRowItem
          name={`${ProductDesc.trim()} ${VarietyDesc.trim()} ${SizeID.trim()}`} 
          icon={<AppleIcon />}
        />
      </TitleRow>
      {
        GrowerID ?
        <TitleRow>
          {handleOpenGrowerModal && (
            <GrowerButtonWrapper onClick={handleGrowerClick}>
              <EditIcon />
            </GrowerButtonWrapper>
          )}
          <TitleRowItem
            name={GrowerName?.trim() || ''} 
            icon={<UserIcon />}
          />
        </TitleRow> : 
        <TitleRow>
          {handleOpenGrowerModal && (
            <GrowerButtonWrapper onClick={handleGrowerClick}>
              <EditIcon />
            </GrowerButtonWrapper>
          )}
          <TitleRowItem
            name="בחר מגדל" 
            icon={<UserIcon />}
          />
        </TitleRow>
      }
      <TitleRow>
        <RowInput 
          width={6}
          icon={<PackageIcon />}
          iconColor={'#297F76'}
          defValue={NumPackagesActulal}
          handleInput={handleChange}
          isDisabled={!!disabled}
        />
      </TitleRow>
    </TitleLayout>
  )
}

const SidleWrapper = styled.div`
    position: absolute;
    left: 0.5em;
    width: 3.5em;
    height: 3.5em;
    top: calc(50% - 1.75em);
`

const GrowerButtonWrapper = styled.div`
    margin-left: 0.5em;
    cursor: pointer;
    padding: 0.2em;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;
    color: #297F76;
    &:hover {
        opacity: 0.7;
    }
    
    svg {
        width: 1em;
        height: 1em;
    }
`

const AddButtonWrapper = styled.div`
    position: absolute;
    right: -2em;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    padding: 0.2em;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;
    color: #297F76;
    background: white;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0,0,0,0.01);
    &:hover {
        opacity: 0.7;
    }
    
    svg {
        width: 1em;
        height: 1em;
    }
`

export default ProductItem